import * as Yup from 'yup'
import { Screens } from 'constants/common'
import { credentialsRetailSchema } from './credentialsSchema'
import { confirmationCodeSchema } from './confirmationCodeSchema'
import { pocketsSchema } from './pocketsSchema'

export const retailSchema: Partial<Record<Screens, Yup.ObjectSchema<any>>> = {
  [Screens.CREDENTIALS]: credentialsRetailSchema,
  [Screens.CONFIRMATION]: confirmationCodeSchema,
  [Screens.POCKETS]: pocketsSchema,
}

export const getSchema = (activeScreen: Screens) => {
  return retailSchema[activeScreen]
}
